import type { TFunction } from "i18next";

export const getNTMStatusToggleLabel = (
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  t: TFunction<any, any>,
  key: string,
  current: number | boolean,
): string | null => {
  switch (key) {
    case "non_trellis_enrolled_ad_accept_bids":
      return current ?
          t(($) => $.annotations["Non-Trellis Ad Bid Management Enabled"])
        : t(($) => $.annotations["Non-Trellis Ad Bid Management Disabled"]);
    case "non_trellis_enrolled_ad":
      return current ?
          t(($) => $.annotations["Non-Trellis Ad Enrolled"])
        : t(($) => $.annotations["Non-Trellis Ad Unenrolled"]);
    default:
      return null;
  }
};
